import { MappingSchema } from '../mapping';
import { MappingValueResolver } from '../valueResolver/valueResolverBase';

export enum ActivityPlanIntervalType {
  ACCOUNTABLE = 'ACCOUNTABLE',
  OUT_OF_SCOPE = 'OUT_OF_SCOPE',
}

export const activityPlanIntervalTypeValueResolver: MappingValueResolver<ActivityPlanIntervalType> =
  {
    accountable: ActivityPlanIntervalType.ACCOUNTABLE,
    out_of_scope: ActivityPlanIntervalType.OUT_OF_SCOPE,
  };
export const ACTIVITY_PLAN_INTERVAL_TYPE: ActivityPlanIntervalType[] =
  Object.values(ActivityPlanIntervalType);

export class ActivityPlanInterval {
  intervalId: string;
  employeeId: string;
  shiftId: string;

  shiftType: string;
  shiftStart?: Date;
  shiftEnd?: Date;

  intervalStart: Date;
  intervalEnd: Date;
  intervalType: string;
  activityType: ActivityPlanIntervalType;
}

export const ACTIVITY_PLAN_INTERVAL_MAPPING_SCHEMA: MappingSchema<ActivityPlanInterval> =
  {
    title: `ActivityPlanIntervalType`,
    description: ``,
    partitionBy: [{ key: 'intervalStart', transform: 'day' }],
    fields: [
      { name: 'intervalId', type: 'string' },
      { name: 'employeeId', type: 'string' },
      { name: 'shiftId', type: 'string' },
      { name: 'shiftType', type: 'string' },
      {
        name: 'shiftStart',
        type: 'localDateTime',
        optional: true,
        measureType: 'local-date-time',
      },
      {
        name: 'shiftEnd',
        type: 'localDateTime',
        optional: true,
        measureType: 'local-date-time',
      },
      {
        name: 'intervalStart',
        type: 'localDateTime',
        measureType: 'local-date-time',
      },
      {
        name: 'intervalEnd',
        type: 'localDateTime',
        measureType: 'local-date-time',
      },
      { name: 'intervalType', type: 'string' },
      {
        name: 'activityType',
        type: { enumValues: ACTIVITY_PLAN_INTERVAL_TYPE },
        defaultValueResolver: activityPlanIntervalTypeValueResolver,
      },
    ],
    includeRawData: true,
    primaryKey: ['intervalId'],
    appendable: true,
  };
